import FirstSnippet from "../../../../content/posts/using-the-contenteditable-attribute/FirstSnippet";
import ExecCommandPaste from "../../../../content/posts/using-the-contenteditable-attribute/ExecCommandPaste";
import BadPaste from "../../../../content/posts/using-the-contenteditable-attribute/BadPaste";
import * as React from 'react';
export default {
  FirstSnippet,
  ExecCommandPaste,
  BadPaste,
  React
};